import React, { Fragment } from "react";
import {
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Table,
  ModalFooter,
} from "reactstrap";
import "../policy-create/paymentDetails.scss";
import convertToRupees from "../../../../utilities/convertToRupees";

const BulkPaymentConfirmModal = (props) => {
  const {
    isOpen,
    toggle,
    loading,
    handleOfflinePaymentSubmit,
    paymentMode,
    bulkPaymentData,
  } = props;

  const {
    totalPolicies = 0,
    totalPremium = 0,
    availableBalance = 0,
    proposerEmail = '',
    proposerMobile = '',
    planName = '',
  } = bulkPaymentData || {};

  return (
    <Fragment>
      <Modal isOpen={isOpen} toggle={toggle} backdrop="static" size="lg">
        {loading ? (
          <ModalHeader>{"Confirm Bulk Payment"}</ModalHeader>
        ) : (
          <ModalHeader toggle={toggle}>{"Confirm Bulk Payment"}</ModalHeader>
        )}
        <ModalBody className="table-first-row-border-hide-modal">
          <div className="mb-3 p-3" style={{ backgroundColor: "#f8f9fa", borderRadius: "8px" }}>
            <h6 className="mb-2" style={{ color: "#00239c", fontWeight: "600" }}>
              <i className="icofont icofont-info-circle"></i> Bulk Upload Summary
            </h6>
            <p className="mb-0" style={{ fontSize: "14px", color: "#666" }}>
              You are about to process <strong>{totalPolicies}</strong> documents
            </p>
          </div>

          <Table className="borderless-table table-first-row-border-hide">
            <tbody>
              <tr>
                <th style={{ width: "40%" }}>Total Documents:</th>
                <td>
                  <strong style={{ fontSize: "16px", color: "#00239c" }}>
                    {totalPolicies}
                  </strong>
                </td>
              </tr>
              {planName && (
                <tr>
                  <th>Plan:</th>
                  <td>{planName}</td>
                </tr>
              )}
              <tr>
                <th>Total Amount:</th>
                <td>
                  <strong style={{ fontSize: "18px", color: "#28a745" }}>
                    {convertToRupees(totalPremium || 0)}
                  </strong>
                </td>
              </tr>
              <tr>
                <th>Available Balance:</th>
                <td>
                  <span style={{ 
                    fontSize: "16px", 
                    color: availableBalance >= totalPremium ? "#28a745" : "#dc3545",
                    fontWeight: "600"
                  }}>
                    {convertToRupees(availableBalance || 0)}
                  </span>
                  {availableBalance < totalPremium && (
                    <span className="ml-2 badge badge-danger">Insufficient Balance</span>
                  )}
                </td>
              </tr>
              <tr>
                <th>Payment Mode:</th>
                <td>
                  <span className="badge badge-primary" style={{ fontSize: "13px", padding: "6px 12px" }}>
                    {paymentMode?.toLowerCase() === "offline"
                      ? "EA Wallet"
                      : paymentMode?.toLowerCase() === "online"
                        ? "Payment Gateway"
                        : "Wallet Payment"}
                  </span>
                </td>
              </tr>
              {proposerMobile && (
                <tr>
                  <th>Contact Mobile:</th>
                  <td>{proposerMobile}</td>
                </tr>
              )}
              {proposerEmail && (
                <tr>
                  <th>Contact Email:</th>
                  <td>{proposerEmail}</td>
                </tr>
              )}
            </tbody>
          </Table>

          <div className="text-center mt-3 pt-3" style={{ borderTop: "1px solid #dee2e6" }}>
            <p className="mb-0" style={{ fontSize: "14px", color: "#666" }}>
              Before submitting your request, please confirm the above details
            </p>
          </div>
        </ModalBody>
        <ModalFooter className="d-flex justify-content-center">
          <Button color="danger" onClick={toggle} disabled={loading}>
            <i className="icofont icofont-close-line mr-1"></i> Cancel
          </Button>
          <Button
            color="success"
            className="mr-1 btn-pro"
            disabled={loading || availableBalance < totalPremium}
            onClick={(e) => {
              handleOfflinePaymentSubmit(e).then(() => {
                toggle();
              });
            }}
            style={{
              backgroundColor: availableBalance < totalPremium ? "#6c757d" : "#00239c",
              borderColor: availableBalance < totalPremium ? "#6c757d" : "#00239c",
            }}
          >
            {loading ? (
              <>
                <i className="icofont icofont-spinner-alt-4 icofont-spin mr-1"></i>
                Processing {totalPolicies} Documents...
              </>
            ) : (
              <>
                <i className="icofont icofont-check-circled mr-1"></i>
                Confirm & Pay {convertToRupees(totalPremium || 0)}
              </>
            )}
          </Button>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
};

export default BulkPaymentConfirmModal;
